import React, { useEffect, useState } from 'react';

const WorkSection = () => {

  const [stepwork, setWork] = useState([]);
  const [video, setVideo] = useState([]);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/videos`)
      .then((res) => res.json())
      .then((info) => setVideo(info));
  }, []);

  useEffect(() => {
    fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/worksec`)
      .then((res) => res.json())
      .then((info) => setWork(info));
  }, []);


  return (





    <>

      {
        video.map(v => <section className="working-style-three centred pb_120">
          <div className="pattern-layer">
            <div className="pattern-1 float-bob-y" style={{ backgroundImage: 'url(assets/images/shape/shape-39.png)' }} />
            <div className="pattern-2 float-bob-y" style={{ backgroundImage: 'url(assets/images/shape/shape-31.png)' }} />
          </div>
          <div className="auto-container">
            <div data-animation-box className="sec-title mb_55">

              <h2>{v.headingVideo}</h2>
            </div>
            <div className="upper-box mb_50 p_relative">
              <div className="image-shape">
                <div className="shape-1" style={{ backgroundImage: 'url(assets/images/shape/shape-36.png)' }} />
                <div className="shape-2 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-37.png)' }} />
                <div className="shape-3 rotate-me" style={{ backgroundImage: 'url(assets/images/shape/shape-38.png)' }} />
              </div>
              <div className="video-inner" style={{ backgroundImage: `url(${v.videoImage})` }}>
                <div className="video-btn">
                  <a
                    href={v.videoLink}
                    className="lightbox-image video-btn"
                    data-caption
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i className="icon-15" />
                  </a>

                </div>
              </div>
            </div>
            <div className="row clearfix">

              {
                stepwork.map(a => a.stepNumber === '01' && <div className="col-lg-4 col-md-6 col-sm-12 working-block">
                  <div className="working-block-two">
                    <div className="inner-box">
                      <div className="shape" style={{ backgroundImage: 'url(assets/images/shape/shape-19.png)' }} />
                      <div className="icon-box">01</div>
                      <h3>{a.stepTitle}</h3>
                      <p>{a.stepDetails}</p>
                    </div>
                  </div>
                </div>)}


              {
                stepwork.map(b => b.stepNumber === '02' && <div className="col-lg-4 col-md-6 col-sm-12 working-block">
                  <div className="working-block-two">
                    <div className="inner-box">
                      <div className="shape" style={{ backgroundImage: 'url(assets/images/shape/shape-19.png)' }} />
                      <div className="icon-box">02</div>
                      <h3>{b.stepTitle}</h3>
                      <p>{b.stepDetails}</p>
                    </div>
                  </div>
                </div>)}

              {
                stepwork.map(c => c.stepNumber === '03' && <div className="col-lg-4 col-md-6 col-sm-12 working-block">
                  <div className="working-block-two">
                    <div className="inner-box">
                      <div className="icon-box">03</div>
                      <h3>{c.stepTitle}</h3>
                      <p>{c.stepDetails}</p>
                    </div>
                  </div>
                </div>)}



            </div>
          </div>
        </section>)
      }


    </>




  );
};

export default WorkSection;